export default __webpack_public_path__ + "47fee7abe61a3119e9739628c8c52b9f.gltf";